<template>
  <div>
    <h1>Manajemen Pengguna</h1>
    <p>Menampilkan semua pengguna yang terdaftar di sistem.</p>

    <div v-if="loading" class="loading-message">Memuat daftar pengguna...</div>
    <div v-if="error" class="error-message">{{ error }}</div>

    <div v-if="!loading && users.length > 0" class="table-container">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Nama</th>
            <th>Email</th>
            <th>Peran</th>
            <th>Status</th>
            <th>Jml Rekening</th>
            <th>Diupdate Oleh</th> <!-- KOLOM BARU -->
            <th>Tgl Update</th>   <!-- KOLOM BARU -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.full_name }}</td>
            <td>{{ user.email }}</td>
            <td><span class="role-badge">{{ user.role }}</span></td>
            <td>
              <span class="status-badge" :class="`status-${user.status.toLowerCase()}`">
                {{ user.status }}
              </span>
            </td>
            <td>{{ user.accounts.length }}</td>
            <td>{{ user.updated_by?.full_name || '-' }}</td>
            <td>{{ user.updated_at ? formatDateTime(user.updated_at) : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '@/services/api';
import { useToast } from 'vue-toastification';
import { formatDateTime } from '@/utils/formatters';

const users = ref([]);
const loading = ref(true);
const error = ref(null);
const toast = useToast();

onMounted(async () => {
  try {
    const response = await api.getAllUsers();
    users.value = response.data;
  } catch (err) {
    error.value = "Gagal memuat data pengguna. Anda mungkin tidak memiliki hak akses.";
    toast.error(error.value);
    console.error(err);
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
  /* Style dasar bisa disalin dari halaman admin lain */
  .table-container { overflow-x: auto; margin-top: 1.5rem; }
  table { width: 100%; border-collapse: collapse; }
  th, td { padding: 0.75rem; text-align: left; border-bottom: 1px solid #ddd; }
  th { background-color: #f8f9fa; }
  .role-badge { 
    background-color: #6c757d; 
    color: white;
    padding: 0.2em 0.5em;
    border-radius: 0.25rem;
    font-size: 0.8em;
  }
  /* Salin style untuk .status-badge dari DashboardPage */
  .status-badge { display: inline-block; padding: 0.25em 0.6em; font-size: 0.75rem; font-weight: 700; border-radius: 0.25rem; color: #fff; }
  .status-active { background-color: #28a745; }
  .status-pending { background-color: #ffc107; color: #212529; }
</style>